import { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams, Outlet } from "react-router-dom";
import { Menu, ConfigProvider, Breadcrumb } from "antd";
import { useSelector } from "react-redux";
import { findDeep, getReleaseDetail } from "@/utils";

import dataJson from "@/../public/data.json";

const prefix = "appDetail";
import "./index.less";

function AppDetail() {
  const { app_detail, release, one_bars } = dataJson;
  const [current, setCurrent] = useState("");
  const [items, setItems] = useState<any[]>([]);
  const [breadCrumbFirst, setBreadCrumbFirst] = useState<string>("");
  // const [breadCrumbSecond, setBreadCrumbSecond] = useState<string>("");

  const releaseDetail = useSelector((state: any) => state.releaseDetail);

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const { type, id } = useParams();

  const typeObj: any = app_detail.type_obj;
  const typeItem = typeObj[type!];

  const onClick = (e: any) => {
    setCurrent(e.key);
    if (e.key === "new") {
      getReleaseDetail(type, releaseDetail?.histories[0]?.id, () => {
        navigate(`${e.item.props.url}/${type}/${id}?rId=${releaseDetail?.histories[0]?.id || id}`);
      });
    } else {
      if (releaseDetail?.histories?.length > 1) {
        getReleaseDetail(type, releaseDetail?.histories[1]?.id, () => {
          navigate(`${e.item.props.url}/${type}/${id}?rId=${releaseDetail?.histories[1]?.id || id}`);
        });
      } else {
        getReleaseDetail(type, releaseDetail?.histories[0]?.id, () => {
          navigate(`${e.item.props.url}/${type}/${id}?rId=${releaseDetail?.histories[0]?.id || id}`);
        });
      }
    }
  };

  useEffect(() => {
    if (releaseDetail) {
      // 修改菜单
      // 获取卡片类型对象
      setBreadCrumbFirst(typeItem?.label);
      const menuItems = app_detail.menu.filter((item) => typeItem.detail_menu.includes(item.key));

      // if (current === "old" || current === "new") {
      //   setBreadCrumbSecond(releaseDetail?.name);
      // } else {
      //   const menuObj = findDeep(menuItems, current, "key");
      //   setBreadCrumbSecond(menuObj?.label);
      // }

      if (releaseDetail?.histories?.length === 1) {
        //
        if (releaseDetail?.histories[0]?.id !== id) {
          navigate(
            `/app_detail/${current}/${type}/${releaseDetail?.histories[0]?.id}?rId=${releaseDetail?.histories[0]?.id}`
          );
          getReleaseDetail(type, releaseDetail?.histories[0]?.id);
        }
        //
        const histories0 = releaseDetail?.histories[0];
        const resShowMode = findDeep(release.show_mode_arr, histories0?.showMode);
        const showModeLabel =
          (histories0?.version ? histories0?.version : "新版本") + one_bars + resShowMode?.menuLabel;
        const newMenuItems = menuItems.map((item) => {
          if (item.key == "release") {
            return {
              ...item,
              label: typeItem.typeName + item.label,
              children: [
                {
                  label: <span title={showModeLabel}>{showModeLabel}</span>,
                  key: "new",
                  url: "/app_detail/new",
                  icon: histories0?.version ? null : (
                    <img src={app_detail.new_icon} className={`${prefix}-menu-icon`} />
                  ),
                },
              ],
            };
          } else {
            return { ...item, label: typeItem.typeName + item.label };
          }
        });
        setItems(newMenuItems);
      } else {
        // 第一条是新版本自身的，第二条是最近的旧版本
        const histories0 = releaseDetail?.histories[0];
        const histories1 = releaseDetail?.histories[1];
        const showMode0 = findDeep(release.show_mode_arr, histories0?.showMode);
        const showMode1 = findDeep(release.show_mode_arr, histories1?.showMode);
        const showModeLabel0 = (histories0?.version ? histories0?.version : "新版本") + one_bars + showMode0?.menuLabel;
        const showModeLabel1 = histories1?.version + one_bars + showMode1?.menuLabel;
        const newMenuItems = menuItems.map((item) => {
          if (item.key == "release") {
            return {
              ...item,
              label: typeItem.typeName + item.label,
              children: [
                {
                  label: <span title={showModeLabel0}>{showModeLabel0}</span>,
                  key: "new",
                  url: "/app_detail/new",
                  icon: histories0?.version ? null : (
                    <img src={app_detail.new_icon} className={`${prefix}-menu-icon`} />
                  ),
                },
                {
                  label: <span title={showModeLabel1}>{showModeLabel1}</span>,
                  key: "old",
                  url: `/app_detail/old`,
                },
              ],
            };
          } else {
            return { ...item, label: typeItem.typeName + item.label };
          }
        });
        setItems(newMenuItems);
      }
    }
  }, [releaseDetail]);

  useEffect(() => {
    const pathArr = pathname.split("/");
    setCurrent(pathArr[pathArr.length - 3]);
  }, [pathname]);
  return (
    <div className={prefix}>
      <div className={`${prefix}-menu-wrap`}>
        <ConfigProvider
          theme={{
            components: {
              Menu: {
                itemColor: "rgba(0,0,0,0.9)",
                itemActiveBg: "#0A59F7",
                itemHoverBg: "#0A59F7",
                itemHoverColor: "#fff",
                itemSelectedBg: "#0A59F7",
                itemSelectedColor: "#fff",
                itemBorderRadius: 0,
                itemHeight: 56,
                groupTitleFontSize: 26,
                subMenuItemBg: "#fff",
              },
            },
          }}
        >
          <Menu
            onClick={onClick}
            mode="inline"
            items={items}
            defaultOpenKeys={["release"]}
            selectedKeys={[current]}
            className={`${prefix}-menu`}
          />
        </ConfigProvider>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Button: { colorPrimary: "#0A59F7" },
            Tabs: { colorPrimary: "#0A59F7" },
          },
        }}
      >
        <div className={`${prefix}-breadCrumb`}>
          <Breadcrumb items={[{ title: breadCrumbFirst }, { title: releaseDetail?.name }]} />
        </div>

        <Outlet />
      </ConfigProvider>
    </div>
  );
}

export default AppDetail;
